module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAuCAYAAADp73NqAAAAAXNSR0IArs4c6QAAABtJREFUGFdj+Pr1638GuhFfvnz5z/D//386EwCHQrSUMRMXcwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_tableau_small.png
// module id = 1Pt2
// module chunks = 2